import script from "./AlertSeverityPill.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertSeverityPill.vue?vue&type=script&setup=true&lang=js"

import "./AlertSeverityPill.vue?vue&type=style&index=0&id=4deca2cb&lang=scss"

const __exports__ = script;

export default __exports__